import { faBullseyeArrow } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';
import { NoDataWrapper } from './common';

export const ProjectFinancialsCardEmptyState: FC = () => {
  return (
    <NoDataWrapper>
      <CardEmptyState
        image={<EmptyStateIcon icon={faBullseyeArrow} />}
        message={
          <FormattedMessage id="project.financials.empty_state.message" />
        }
      />
    </NoDataWrapper>
  );
};
